import { render, staticRenderFns } from "./ReferralCampaignHeadline.vue?vue&type=template&id=71915c24&scoped=true"
import script from "./ReferralCampaignHeadline.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralCampaignHeadline.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReferralCampaignHeadline.vue?vue&type=style&index=0&id=71915c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71915c24",
  null
  
)

export default component.exports